import script from "./BaseTableElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTableElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTableElement.vue?vue&type=style&index=0&id=3eff7eba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eff7eba"]])

export default __exports__